<style scoped>
.res-qrcode-box {
  width: 280px;
  height: 280px;
  text-align: center;
  margin: 11px auto 0 auto;
  color: #384044;
  font-size: 18px;
  position: relative;
  cursor: pointer;
}
.res-mask {
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  width: 280px;
  height: 280px;
  position: absolute;
  top: 0;
  border: solid 1px transparent;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
  color: #FFFFFF;
  font-size: 12px;
  line-height: 16px;
}
</style>
<template>
  <!-- <div id="wxframe" class="text-center m-t-10"></div> -->
  <div style="text-align:center;">
    <!-- <div class="res-qrcode-box">
       <div v-if="!codeEffective" @click="getwxCode" class="res-mask">二维码失效<br>请点击刷新</div>
        <img :src="wxcodeUrl" style="width: 280px;"/>
    </div> -->
    <iframe :src="wxloginUrl" height="400" frameborder="0"></iframe>

    <div v-if="wxcodeUrl!==''">
      <img src="../assets/imgs/wx.jpg" alt="logo" style="width: 24px;height: 24px;vertical-align: top;margin-right: 8px;">
      <p style="font-size: 13px;color:#737C84;">请使用微信扫描二维码登录</p>
      <p style="font-size: 13px;color:#737C84;">"欧孚士"</p>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
import { getWxLoginPage } from '@/api/loginV2'
import { checkqrcode } from '@/api/login'
// import { setStorage } from '@/utils/storage'
// const qs = require('qs')

export default {
  data () {
    return {
      wxcodeUrl: '',
      userInfo: '',
      codeEffective: true,
      requestTag: 0, // 请求次数

      wxloginUrl: ''
    }
  },
  created () {
    this.getwxCode()
  },
  methods: {
    getwxCode () {
      // this.requestTag = 0
      // let query = {
      //   appid: this.$store.state.main.wxappid
      // }
      // getNewWxCode(query).then(res => {
      //   this.codeEffective = true
      //   this.wxcodeUrl = res.url
      //   this.reloadCodeStatus(res.number)
      // })

      getWxLoginPage().then(res => {
        this.wxloginUrl = res
      })
    },
    // 刷新二维码扫码情况
    reloadCodeStatus (number) {
      this.requestTag++
      const that = this
      let query = {
        number: number
      }
      checkqrcode(query).then(res => {
        if (res.status === -1) {
          that.codeEffective = false
        } else if (res.status === 1) {
          that.userLogin(res.msg)
          that.$store.commit('set_userInfo_openId', res.msg)
        } else if (res.status === 0 && this.requestTag < 60) {
          setTimeout(function () {
            that.reloadCodeStatus(number)
          }, 1000)
        } else {
          that.codeEffective = false
        }
      })
    }
    // userLogin (openid) {
    //   // const that = this
    //   let query = {
    //     'grant_type': 'openid',
    //     'appid': this.$store.state.main.wxappid,
    //     'openid': openid
    //   }
    //   axios.post(process.env.API_URL + '/ooh-auth/oauth/token',
    //     qs.stringify(query),
    //     {
    //       headers: {
    //         'Content-Type': 'application/x-www-form-urlencoded',
    //         'Authorization': 'Basic b29oX3B1YmxpYzpvb2hfc2VjcmV0X3B1YmxpYw=='
    //       }
    //     }
    //   ).then(res => {
    //     this.$store.commit('set_userInfo_user', res.data)
    //     setStorage('authToken', `${res.data.token_type} ${res.data.access_token}`, 10800)
    //     setStorage('refresh-token', res.data.refresh_token, 10800)
    //   })
    // }
  }
}
</script>
